import config from 'config/config';

import cloudinaryFactory from '../../libraries/utils/cloudinary-factory';

export default cloudinaryFactory(config.cloudinary.url);
